import { render, staticRenderFns } from "./InternalResource.vue?vue&type=template&id=2dfd9f63&scoped=true"
import script from "./InternalResource.vue?vue&type=script&lang=js"
export * from "./InternalResource.vue?vue&type=script&lang=js"
import style0 from "./InternalResource.vue?vue&type=style&index=0&id=2dfd9f63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfd9f63",
  null
  
)

export default component.exports